import * as Types from '../../generated/types';

import gql from 'graphql-tag';
export type AppFooterStoreFragment = { __typename?: 'Store', name: string, theme: { __typename?: 'StoreTheme', brandLogo?: { __typename?: 'ImageMedia', image?: { __typename?: 'Image', url: any } | null } | null }, businessInfo: { __typename?: 'BusinessInfo', businessNumber: string, onlineBusinessNumber: string, representativeName: string, companyName?: string | null, registrationDate?: any | null }, address: { __typename?: 'StoreAddress', zipcode: string, siDo: string, siGunGu: string, eupMyeonDong: string, addressLine1: string, addressLine2?: string | null }, customerService: { __typename?: 'CustomerService', phoneNumber: string, email: string, operatingHours: { __typename?: 'OperatingHours', weekdayStart: any, weekdayEnd: any, weekendStart?: any | null, weekendEnd?: any | null, lunchStart?: any | null, lunchEnd?: any | null, holidays?: string | null }, returnAddress?: { __typename?: 'ShippingAddress', zipcode: string, siDo: string, siGunGu: string, eupMyeonDong: string, addressLine1: string, addressLine2?: string | null, recipientName: string, recipientPhone: string } | null }, privacyOfficer: { __typename?: 'PrivacyOfficer', name: string, email: string, phoneNumber: string } };

export const AppFooterStoreFragmentDoc = gql`
    fragment AppFooterStore on Store {
  name
  theme {
    brandLogo {
      image {
        url
      }
    }
  }
  businessInfo {
    businessNumber
    onlineBusinessNumber
    representativeName
    companyName
    registrationDate
  }
  address {
    zipcode
    siDo
    siGunGu
    eupMyeonDong
    addressLine1
    addressLine2
  }
  customerService {
    phoneNumber
    email
    operatingHours {
      weekdayStart
      weekdayEnd
      weekendStart
      weekendEnd
      lunchStart
      lunchEnd
      holidays
    }
    returnAddress {
      zipcode
      siDo
      siGunGu
      eupMyeonDong
      addressLine1
      addressLine2
      recipientName
      recipientPhone
    }
  }
  privacyOfficer {
    name
    email
    phoneNumber
  }
}
    `;